import React from 'react';
import { APP_MODES, getAppMode } from '../../../utils/urlHelpers';
import Step1ContainerLegacy from './Step1ContainerLegacy';
import Step1ContainerMultiFleet from './Step1ContainerMultiFleet';

const appMode = getAppMode();
const isMultiFleetEnabled = appMode.includes(APP_MODES.FLEET_TYPES);

export const Step1Container = (props) =>
  isMultiFleetEnabled ? (
    <Step1ContainerMultiFleet {...props} />
  ) : (
    <Step1ContainerLegacy {...props} />
  );

export default Step1Container;
